<template>
    <div class="mt-1">
        <b-button variant="primary" @click="handleSelectClick">Select</b-button>
    </div>
</template>

/* * *cancel-downgrade * */

<script>
    import capitalize from 'lodash/capitalize';

    export default {
        computed: {},
        methods: {
            async handleSelectClick() {
                this.params.onSelect(this.params.data.id);
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.btn) {
        width: 130px !important;
        text-transform: capitalize !important;
        font-size: 14px !important;
    }
</style>
